import ErnstigeBloedingenOnderTar from "../../../../src/client/lta-antistolling/ernstige-bloedingen-onder-tar.json";
import * as React from 'react';
export default {
  ErnstigeBloedingenOnderTar,
  React
};